var map = {
	"./data-accounts-dark.svg": [
		9916,
		916
	],
	"./data-accounts-light.svg": [
		6706,
		706
	],
	"./data-assets-dark.svg": [
		598,
		598
	],
	"./data-assets-light.svg": [
		8484,
		484
	],
	"./data-calls-dark.svg": [
		4655,
		655
	],
	"./data-calls-light.svg": [
		1902,
		902
	],
	"./data-destroyed_assets-dark.svg": [
		769,
		769
	],
	"./data-destroyed_assets-light.svg": [
		5424,
		424
	],
	"./data-destroyed_foreign_assets-dark.svg": [
		5990,
		990
	],
	"./data-destroyed_foreign_assets-light.svg": [
		7438,
		38
	],
	"./data-destroyed_nft-dark.svg": [
		3767,
		767
	],
	"./data-destroyed_nft-light.svg": [
		4456,
		456
	],
	"./data-events-dark.svg": [
		9421,
		421
	],
	"./data-events-light.svg": [
		2691,
		863
	],
	"./data-extrinsics-dark.svg": [
		8621,
		621
	],
	"./data-extrinsics-light.svg": [
		5158,
		158
	],
	"./data-foreign_assets-dark.svg": [
		8749,
		749
	],
	"./data-foreign_assets-light.svg": [
		5,
		5
	],
	"./data-identities-dark.svg": [
		910,
		910
	],
	"./data-identities-light.svg": [
		7338,
		338
	],
	"./data-identity_judgements-dark.svg": [
		394,
		394
	],
	"./data-identity_judgements-light.svg": [
		1254,
		254
	],
	"./data-identity_registrars-dark.svg": [
		691,
		691
	],
	"./data-identity_registrars-light.svg": [
		8697,
		697
	],
	"./data-multisig_accounts-dark.svg": [
		9437,
		437
	],
	"./data-multisig_accounts-light.svg": [
		7488,
		488
	],
	"./data-multisigs-dark.svg": [
		3031,
		31
	],
	"./data-multisigs-light.svg": [
		2439,
		439
	],
	"./data-nft-dark.svg": [
		2642,
		642
	],
	"./data-nft-light.svg": [
		376,
		376
	],
	"./data-proxy-dark.svg": [
		3746,
		746
	],
	"./data-proxy-light.svg": [
		2674,
		527
	],
	"./data-recoverables-dark.svg": [
		600,
		600
	],
	"./data-recoverables-light.svg": [
		3735,
		438
	],
	"./data-recoveries-dark.svg": [
		3154,
		154
	],
	"./data-recoveries-light.svg": [
		2088,
		88
	],
	"./data-recovery_proxies-dark.svg": [
		1820,
		820
	],
	"./data-recovery_proxies-light.svg": [
		1193,
		193
	],
	"./data-transfers-dark.svg": [
		545,
		545
	],
	"./data-transfers-light.svg": [
		3584,
		640
	],
	"./data-vestings-dark.svg": [
		1167,
		167
	],
	"./data-vestings-light.svg": [
		8668,
		668
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3745;
module.exports = webpackAsyncContext;